// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2jy_N","approved":"Status_approved__cdPaB","rejected":"Status_rejected__2EQyC","expired":"Status_expired__1V7ge","label":"Status_label__32JLH"};